const NAME = {
  id: 'invited_name',
  label: 'list.name',
  type: 'link',
  link: {
    to: 'invitesDetail',
    params: { id: 'id' },
    tag: 'a'
  }
}
const PERMISSION = {
  id: 'permission',
  label: 'list.permission',
  type: 'text'
}
const EMAIL = {
  id: 'invited_email',
  label: 'list.email',
  type: 'text'
}

const STATUS = {
  id: 'status.value',
  key: 'status.key',
  label: 'list.status',
  type: 'status'
}

const EXPIRES = {
  id: 'expires_at',
  label: 'list.expires',
  type: 'text'
}

const FIELDS = [NAME, EMAIL, STATUS, PERMISSION, EXPIRES]

export { FIELDS }
